import React, { useState } from 'react';
import { EvaluationStep } from './EvaluationStep';
import { EvaluationRisk } from './EvaluationRisk';
import { EvaluationCategoriesStep } from './EvaluationCategoriesStep';
import { EvaluationCategoryQuestions } from './EvaluationCategoryQuestions';

export function EvaluationControlStep(): JSX.Element {
	const [subStep, setSubStep] = useState<number>(1);

	function goToSubStep(step: number) {
		setSubStep(step);
	}

	return (
		<>
			{subStep === 1 && <EvaluationStep goToSubStep={goToSubStep} />}
			{subStep === 2 && <EvaluationCategoriesStep goToSubStep={goToSubStep} />}
			{subStep === 3 && <EvaluationCategoryQuestions goToSubStep={goToSubStep} />}
			{subStep === 4 && <EvaluationRisk goToSubStep={goToSubStep} />}
		</>
	);
}
